export default __webpack_public_path__ + "b43db6f177e02759f8843860f16d2b47.gif";